"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellBarChart = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var theme_1 = require("../../../utils/theme");
var BAR_HEIGHT = 16;
exports.TableCellBarChart = function (_a) {
    var value = _a.value, colorScale = _a.colorScale, domain = _a.domain, cellWidth = _a.cellWidth, cellHeight = _a.cellHeight;
    var chartMargin = {
        top: 4,
        bottom: 4,
        left: 4,
        right: 4,
    };
    var xScale = d3
        .scaleLinear()
        .domain(domain)
        .range([chartMargin.left, cellWidth - chartMargin.right]);
    var chartHeight = cellHeight - chartMargin.top - chartMargin.bottom;
    return (react_1.default.createElement("svg", { height: cellHeight, width: cellWidth },
        react_1.default.createElement("g", { transform: "translate(" + chartMargin.left + ", " + chartMargin.top + ")" },
            react_1.default.createElement("rect", { x: xScale(Math.min(value, 0)), y: chartHeight / 2 - BAR_HEIGHT / 2, width: Math.abs(xScale(value) - xScale(0)), height: BAR_HEIGHT, fill: colorScale(value) }),
            react_1.default.createElement("line", { x1: xScale(0), y1: 0, x2: xScale(0), y2: chartHeight, stroke: theme_1.theme.colors.NTDarkGrey[200] }))));
};
